<script setup>
import { useField } from 'vee-validate'

const props = defineProps(['field', 'modelValue'])
const rules = { required: props.field.required }

if (props.field.field_type == 'url') rules.url = true
if (props.field.field_type == 'email') rules.email = true
if (props.field.field_type == 'number') rules.numeric = true

const { value: model } = useField(
  () => props.field.clean_name,
  rules,
  {
    syncVModel: true,
  }
)

const types = {
  singleline: 'text',
  multiline: 'textarea',
  email: 'email',
  number: 'text',
  url: 'url',
  hidden: 'hidden',
}
</script>

<template>
  <b-input
    v-model="model"
    :type="types[field.field_type]"
    :placeholder="field.placeholder"
    custom-class="is-large is-size-6"
    :name="field.clean_name"
    v-bind="{
      maxlength: field.max_length,
      'use-html5-validation': false,
      required: field.required,
    }"
  >
  </b-input>
</template>
